export default {
  schema__ERROR_SAME_TIME: "Return time must be after pick-up time.",
  schema__ERROR_MAX_DATE: (date) => `Please enter a date earlier than ${date}.`,
  schema__ERROR_MIN_DATE: (date) => `Please enter a date after ${date}.`,
  schema__PICKUP_DATE: "Pick-up date",
  schema__PICKUP_LOCATION: "Pick-up location",
  schema__RETURN_LOCATION: "Return location",
  schema__RETURN_DATE: "Return date",
  schema__RETURN_TIME: "Return time",
  schema__VALID_PICKUP_DATE: "Enter valid pick-up date.",
  schema__VALID_RETURN_DATE: "Enter valid return date.",
};
